export default function useGallery() {
	const { $pb } = useNuxtApp();
	const fetchImages = async (options?: { highlight?: boolean }) => {
		const result = (await $pb.collection("gallery").getFullList({
			filter: `highlight = ${options?.highlight ? "true" : "false"}`,
		})) as unknown as GalleryImage[];

		return result;
	};

	return {
		fetchImages,
	};
}
